import { isFuture } from 'date-fns';

export default function checkHasValidStartDate(startDate) {
  if (!startDate) {
    return false;
  }

  return isFuture(new Date(startDate));
}
